import { apiClient } from '../client'
import type {
  AcceptInviteRequest,
  InviteTenantMemberRequest,
  SetIPAllowlistRequest,
  SetMemberRoleRequest,
  TenantAccount,
  TenantInvite,
  TenantMember,
  TenantQuota,
} from '@milliswift/types'

/**
 * Tenant self-management (services/tenants). These routes complement the
 * older orgs routes: /account scopes to the caller's own tenant, so there is
 * no org ID to thread through.
 */
export const tenantsApi = {
  getAccount: () => apiClient.get<TenantAccount>('/account').then((r) => r.data),

  getQuota: () => apiClient.get<TenantQuota>('/account/quota').then((r) => r.data),

  /** Admin-only: restrict which networks API keys may be used from. */
  setIPAllowlist: (data: SetIPAllowlistRequest) =>
    apiClient.put<TenantAccount>('/account/ip-allowlist', data).then((r) => r.data),

  listMembers: () => apiClient.get<TenantMember[]>('/account/members').then((r) => r.data),

  inviteMember: (data: InviteTenantMemberRequest) =>
    apiClient.post<TenantInvite>('/account/members/invite', data).then((r) => r.data),

  setMemberRole: (userId: string, data: SetMemberRoleRequest) =>
    apiClient.patch<TenantMember>(`/account/members/${userId}`, data).then((r) => r.data),

  removeMember: (userId: string) =>
    apiClient.delete(`/account/members/${userId}`).then(() => undefined),

  acceptInvite: (data: AcceptInviteRequest) =>
    apiClient.post<{ tenant_id: string; role: string }>('/account/invites/accept', data).then((r) => r.data),

  revokeInvite: (inviteId: string) =>
    apiClient.delete(`/account/invites/${inviteId}`).then(() => undefined),
}
